import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { Container, Row, Col } from "react-bootstrap";
import SubsiteService from "../../services/subsite.service";
import {getSubsite} from "../../reducers/auth";


const CloneProductModal = (props) => {
  const [allSubsites, setAllSubsites] = useState([]);
  const [selectedSubsites, setSelectedSubsites] = useState([]);
  const currentSubsite = useSelector(getSubsite);

  const modalClose = () => {
    props.closeModal(false);
  }
  useEffect(() => {
    async function fetchData(setAllSubsites) {
      var subsites = await SubsiteService.getAllSubsites();
      console.log("SUBSITES", subsites.data);
      setAllSubsites(subsites.data);
    }
    fetchData(setAllSubsites);
    
  }, []);

  useEffect(() => {
    console.log("allSubsites", allSubsites);
  }, [allSubsites]);


  const handleSubmit = () => {
    props.cloneProduct(selectedSubsites);
    props.closeModal(false);
  }

  const addRemoveSubsite = (e, subsite) => {
    if(e.target.checked) {
      setSelectedSubsites([...selectedSubsites, subsite]);
    } else {
      setSelectedSubsites(selectedSubsites.filter((item) => item.id !== subsite.id));
    }
  }

  return (
    <Modal show={props.show} onHide={modalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Clone Product<br /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              Subsites:
            </Col>
          </Row>
            {allSubsites && allSubsites.length > 0 && allSubsites.map((subsite) => {
              if(subsite.id === currentSubsite.id) {
                return <></>;
              } else {
                return (
                  <Row><Col>
                  <input type="checkbox" id={subsite.id} name={subsite.id} onClick={(e) => addRemoveSubsite(e, subsite)}/> {subsite.subsiteName}
                  </Col></Row>
                );
              }
            })}
          <Row>
            <Col>
              <Button onClick={handleSubmit}>Add To Subsites</Button>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default CloneProductModal; 